// extracted by mini-css-extract-plugin
export default {"container":"PharmacyOrdersInbox_container__nmET3","footer":"PharmacyOrdersInbox_footer__sIBGY","filedStatus":"PharmacyOrdersInbox_filedStatus__4QC4W"};